import { mergeAttributes, Node } from '@tiptap/core';
import { getCustomEmoji } from './comment-custom-emojis';

export const CustomEmoji = Node.create({
  name: 'customEmoji',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-custom-emoji'),
        renderHTML: (attributes) =>
          attributes.name ? { 'data-custom-emoji': attributes.name } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'img[data-custom-emoji]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const custom = getCustomEmoji(`:${node.attrs.name}:`);
    return [
      'img',
      mergeAttributes(HTMLAttributes, {
        'data-custom-emoji': node.attrs.name,
        src: custom?.src ?? '',
        alt: `:${node.attrs.name}:`,
        title: `:${node.attrs.name}:`,
        class: 'custom-emoji',
        draggable: 'false',
      }),
    ];
  },

  renderText({ node }) {
    return `:${node.attrs.name}:`;
  },
});
